import React from "react";
import styles from "./styles/Divider.module.css";

function Divider({mainId}) {
    return (
        <div className={styles.dividerContainer} id={mainId}>
            <div className={styles.divider}></div>
        </div>
    );
}

export default Divider;
